import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { TFunction } from '@lyearn/i18n';
import { AppConfig } from '@/hooks/useAppConfig';
import { EventTypeEnum } from '@/types/schema';

function getEventFilterTypes(
  t: TFunction,
  appConfig: AppConfig,
  filterValueType: 'all' | 'recurring' | 'non-recurring' = 'non-recurring',
) {
  const isRecurringType = filterValueType === 'recurring';

  return getEnabledItems([
    {
      value: EventTypeEnum.Live,
      label: t('Common:Filter.Live'),
      enabled: appConfig.site.allowedSessionTypes?.includes(EventTypeEnum.Live) && !isRecurringType,
    },
    {
      value: EventTypeEnum.External,
      label: t('Common:Filter.External'),
      enabled:
        appConfig.site.allowedSessionTypes?.includes(EventTypeEnum.External) && !isRecurringType,
    },
    {
      value: EventTypeEnum.Offline,
      label: t('Common:Filter.Offline'),
      enabled:
        appConfig.site.allowedSessionTypes?.includes(EventTypeEnum.Offline) && !isRecurringType,
    },
    {
      value: EventTypeEnum.RecurringLive,
      label: isRecurringType ? t('Common:Filter.Live') : t('Common:Filter.RecurringLive'),
      enabled:
        appConfig.site.allowedSessionTypes?.includes(EventTypeEnum.Live) &&
        filterValueType !== 'non-recurring',
    },
    {
      value: EventTypeEnum.RecurringExternal,
      label: isRecurringType ? t('Common:Filter.External') : t('Common:Filter.RecurringExternal'),
      enabled:
        appConfig.site.allowedSessionTypes?.includes(EventTypeEnum.External) &&
        filterValueType !== 'non-recurring',
    },
    {
      value: EventTypeEnum.RecurringOffline,
      label: isRecurringType ? t('Common:Filter.Offline') : t('Common:Filter.RecurringOffline'),
      enabled:
        appConfig.site.allowedSessionTypes?.includes(EventTypeEnum.Offline) &&
        filterValueType !== 'non-recurring',
    },
  ]);
}

export default getEventFilterTypes;
